import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Outline "Filtros" trigger with an optional active-filter count badge.
 *
 * Built locally because the ui-kit has no equivalent: `<ui-button>` cannot place
 * the icon as a suffix, and `<ui-badge>` is a corner-rounded pill
 * (`border-radius: 0 0 16px 0`) rather than the 20x20 circle the design asks for.
 *
 * The icon is the kit's `filter-alt` (kit >= 1.8.14), the same one the backoffice uses
 * for its filter button.
 */
@Component({
  standalone: false,
  selector: 'digicem-filter-button',
  templateUrl: './filter-button.component.html',
})
export class FilterButtonComponent {
  @Input() label = 'Filtros';
  @Input() count = 0;

  @Output() clicked = new EventEmitter<void>();

  protected get hasCount(): boolean {
    return this.count > 0;
  }

  protected get accessibleLabel(): string {
    return this.hasCount ? `${this.label}, ${this.count} activos` : this.label;
  }
}
